import { createContext, useState } from "react"
import { useMutation } from 'react-query';
import {
    searchPortalUser,
} from "../api/apiServices";
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom';

const PortalUserSearchContext = createContext({})

export const PortalUserSearchProvider = ({ children }) => {

    const navigate = useNavigate();
  
    const [searchResult, setSearchResult] = useState({
        search: false,
        portalUser: [],
        pf_number: "",
        mobile_number: "",
        first_name: "",
        last_name: "",
    })

    const [phone_input_name, setPhoneInputName] = useState("")

    const searchMutation = useMutation(searchPortalUser, {
        onSuccess: async (res) => {
            console.log(res)
            if (res.status === true) {
                setSearchResult(prevData => ({
                    ...prevData,
                    portalUser: res.portal_user,
                    search: true,
                    pf_number: "",
                    mobile_number: "",
                    first_name: "",
                    last_name: "",
                }))
            } else {
                toast.error(res.message, {
                    duration: 6000
                })
                setSearchResult(prevData => ({
                    ...prevData,
                    portalUser: [],
                    search: false
                }))
                return false
            }
        },
        onError: async (err) => {

        }
    })

    const handleSearch = async (e) => {
        e.preventDefault();

        const searchData = {
            pf_number: searchResult.pf_number,
            mobile_number: searchResult.mobile_number,
            first_name: searchResult.first_name,
            last_name: searchResult.last_name,
        }
        searchMutation.mutate(searchData)
    }

    const handlePhoneInputName = (e) => {
        const name = e.target.placeholder
        setPhoneInputName(name)
    }

    const handlePhoneChange = (e) => {
        const value = e
        const name = phone_input_name ? phone_input_name : undefined
        setSearchResult(prevData => ({
            ...prevData,
            [name]: value
        }))
    }

    const handleChange = e => {
        const name = e.target.name
        const value = e.target.value
        setSearchResult(prevData => ({
            ...prevData,
            [name]: value
        }))
    }

    const handleCancel = (e) => {
        setSearchResult(prevData => ({
            ...prevData,
            search: false,
            portalUser: [],
        }))
        navigate(-1);
    }

     return (
        <PortalUserSearchContext.Provider value={{
            searchResult,
            setSearchResult,
            handleSearch,
            handlePhoneInputName,
            handlePhoneChange,
            handleChange,
            handleCancel
        }}>
            {children}
        </PortalUserSearchContext.Provider>
    )
}

export default PortalUserSearchContext 